import './index.erb';
import './index.rb';

(() => {
  'use strict';

  const $btnShowMore = $('#btnDisciplineShowMore');

  $btnShowMore.on('click', e => {
    e.preventDefault();

    $btnShowMore.hide();
    $('.no-show').toggleClass('no-show');
  });
})();
